import { BaseService } from "./BaseService";
import { ReservationService } from "./ReservationService";

export class UserService extends BaseService {
  reservationService = new ReservationService();

  constructor() {
    super("/users");
  }

  async auth(credentials) {
    if (!credentials || !credentials.username || !credentials.password) {
      throw new Error("auth requires username and password.");
    }

    try {
      const response = await this.getClient().post(`${this.baseUrl}/auth`, {
        username: credentials.username,
        password: credentials.password,
      });
      return response;
    } catch (error) {
      this.handleError(error);
    }
  }

  async confirmPassword(credentials) {
    if (!credentials || !credentials.username || !credentials.password) {
      throw new Error("auth requires username and password.");
    }

    try {
      const response = await this.getClient().post(
        `${this.baseUrl}/confirm-password`,
        credentials
      );
      return response.data;
    } catch (error) {
      this.handleError(error);
    }
  }

  // 🚀 FIXED: Delegating Reservation Cancellation to ReservationService
  async cancelReservation(reservationId, note) {
    return this.reservationService.cancelReservation(reservationId, note);
  }

  async getNotifications() {
    try {
      const response = await this.getClient().get(`${this.baseUrl}/notifications`);
      return response.data;
    } catch (error) {
      this.handleError(error);
    }
  }

  async getProfile() {
    try {
      const response = await this.getClient().get(`${this.baseUrl}/me`);
      return response.data;
    } catch (error) {
      this.handleError(error);
    }
  }

  async verifyPassword(password) {
    try {
      const response = await this.getClient().post(
        `${this.baseUrl}/verify-password`,
        { password }
      );
      return response.data.isValid;
    } catch (error) {
      console.error("Password verification failed:", error);
      return false;
    }
  }

  async updateProfile(data) {
    try {
      const response = await this.getClient().put(this.baseUrl, data);
      return response.data;
    } catch (error) {
      this.handleError(error);
    }
  }
}

export const userService = new UserService();
